import React, { useEffect, useState } from "react";
import {
    Container,
    Card,
    Table,
} from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { getSite, deleteSite } from "../../store/slices/project";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";


export default function Sites() {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [limit] = useState(20);
    const { siteList = [], loading } = useSelector((state) => state.projectlist);
    useEffect(() => {
        dispatch(
            getSite({
                page,
                limit,
                project: id,
            })
        );
    }, [dispatch, page, limit, id]);

    const projectData = siteList || [];


    const paginatedUsers = projectData;



    const handleEdit = (id) => {
        navigate(`/admin/edit-site/${id}`);
    };

    // delete
    const handleDelete = async (id) => {
        const confirmed = window.confirm(
            "Are you sure you want to delete this project?"
        );

        if (!confirmed) return;
        try {
            await dispatch(deleteSite(id)).unwrap();
            await getSite();
            toast.success("Site deleted successfully")
        } catch (error) {
            console.error(error?.message || error, "Error deleting site:");
        }
    };

    return (
        <>

            <div className="breadcrumb-bar mx-1" >
                <div className="container-fluid">
                    <div className="d-flex  flex-row align-items-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/admin/home" className="breadcrumb-link active">
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>
                            <Link to="/admin/projects" className="breadcrumb-link active">
                                Projects
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span
                                className="breadcrumb-link inactive"

                            >
                                Sites
                            </span>
                        </div>

                        <button
                            className="add-outlet-btn"
                            onClick={() => navigate("/admin/add-site")}
                        >

                            Add Sites
                        </button>

                    </div>
                </div>
            </div>


            <div className="ud-page-wrap">
                <Container fluid>
                    <div className="ud-header">
                        <h2 className="ud-main-title">Sites</h2>

                    </div>



                    {loading ? (
                        <Card className="ud-table-card">
                            <Card.Body
                                className="d-flex justify-content-center align-items-center"
                                style={{ minHeight: "300px" }}
                            >
                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                    style={{
                                        width: "4rem",
                                        height: "4rem",
                                    }}
                                >
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </div>
                            </Card.Body>
                        </Card>
                    ) : (
                        <Card className="ud-table-card">
                            <Card.Body className="p-0">
                                <div className="ud-scroll-wrap">
                                    <Table
                                        hover
                                        borderless
                                        className="ud-table align-middle mb-0"
                                    >
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Project</th>
                                                <th>Plot No</th>
                                                <th>Facing</th>
                                                <th>Dimension</th>
                                                <th>Area (Sqft)</th>
                                                <th>Status</th>
                                                <th>Price</th>
                                                <th>Action</th>

                                            </tr>
                                        </thead>

                                        <tbody>
                                            {paginatedUsers.length > 0 ? (

                                                paginatedUsers.map((site, index) => (
                                                    <tr key={site._id}>
                                                        <td>{index + 1}</td>


                                                        <td>{site.project?.projectName}</td>
                                                        <td>{site.plotNo}</td>

                                                        <td>{site.facing}</td>

                                                        <td>{site.dimension}</td>

                                                        <td>{site.areaSqft}</td>

                                                        <td>{site.status}</td>

                                                        <td>{site.plotPrice}</td>

                                                        <td>
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent:
                                                                        "center",
                                                                    alignItems:
                                                                        "center",
                                                                    gap: "10px",
                                                                }}
                                                            >
                                                                <button className="editbtn"
                                                                    onClick={() =>
                                                                        handleEdit(
                                                                            site._id
                                                                        )
                                                                    }
                                                                    title="Edit"

                                                                >
                                                                    <FaEdit
                                                                        size={12}
                                                                    />
                                                                </button>

                                                                <button
                                                                    onClick={() =>
                                                                        handleDelete(
                                                                            site._id
                                                                        )
                                                                    }
                                                                    title="Delete"
                                                                    className="deletebtn"
                                                                >
                                                                    <FaTrash
                                                                        size={12}
                                                                    />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan="9"
                                                        className="text-center py-4"
                                                    >
                                                        No Sites Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    )}



                </Container>
            </div>
        </>
    );
}